
import ImageHeader from "@/components/core/ImageHeader";
import ActivityBlog from "@/components/ActivityBlog/ActivityBlog";
import tableLoading from "@/components/tableLoading";
export default {
  //scrollToTop: true,
  components: {
    ImageHeader,
    tableLoading,
    ActivityBlog,
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content:
            "Goa Tourism, Travel Guide, Must do Activities, Top Activities to do in Goa, Goa, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Kayaking, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Offers, Travel Goa",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title + " | Goa App",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: this.title + " | Goa App",
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: this.description,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.title ? this.title : "Goa App",
        },
        {
          hid: "og:image",
          property: "og:image",
          content:
            this.$config.siteUrl + "/img/meta-imgs/blogs-meta-image.webp",
        },
        {
          hid: "image",
          property: "image",
          content:
            this.$config.siteUrl + "/img/meta-imgs/blogs-meta-image.webp",
        },
        {
          hid: "twitter-image",
          property: "twitter:image",
          content:
            this.$config.siteUrl + "/img/meta-imgs/blogs-meta-image.webp",
        },
      ],
    };
  },
  scrollToTop: true,
  data() {
    return {
      title: "Goa App Blog | Top Travel Tips | Insider Guide to Explore Goa",
      description:
        "Explore Our Goa Travel Blog to check for Everything you need to know! Our blog is an ultimate guide to best places to visit in Goa & hidden gems - Goa App",
      blogs: null,
      search: "",
      isSearchClicked: false,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      listings: {},
      itemSelected: -1,
      busy: false,
      productObj: [],
      loading: true,
      listingLoading: true,
      initialLoading: true,
      interLinks: {
        title: "Explore More on Goa App",
        links: [
          {
            sub_title: "Things to Know",
            interLinks: [
              {
                name: "Capital of Goa",
                url: "/blog/panjim-goa-travel-guide capital of Goa",
              },
              {
                name: "Touristy Places in Goa",
                url: "/blog/tourist-places-in-goa",
              },
              {
                name: "All about North Goa",
                url: "/blog/things-to-do-in-north-goa",
              },
              {
                name: "Temples in Goa",
                url: "/blog/hindu-temples-in-goa",
              },
              {
                name: "Bioluminescent Beaches",
                url: "/blog/bioluminescent-beach-goa",
              },
              {
                name: "Mopa Airport",
                url: "/blog/mopa-airport-to-baga-transport",
              },
            ],
          },
          {
            sub_title: "Must Try popular attractions",
            interLinks: [
              {
                name: "WaterSports Booking in Goa",
                url: "/goa/activities/category/water-sports",
              },
              {
                name: "Casino Tickets in Goa",
                url: "/goa/activities/category/entertainment",
              },
              {
                name: "Book Scuba Diving in Goa",
                url: "/activities/scuba-diving-at-grande-island-and-water-sports-combo",
              },
              {
                name: "Book Dudhsagar Waterfall Trek in Goa",
                url: "/activities/dudhsagar-falls-tour-package",
              },
              {
                name: "Offers at Best Restaurants in Goa",
                url: "/offers",
              },
              {
                name: "Music Events",
                url: "/events/music-events",
              },
            ],
          },

          {
            sub_title: "More on Goa App",
            interLinks: [
              {
                name: "Hire a Taxi",
                url: "/taxi",
              },
              {
                name: "Rent a Car",
                url: "/rentals",
              },
              {
                name: "Activities in Goa",
                url: "activities",
              },

              {
                name: "Holiday Packages",
                url: "/packages",
              },
            ],
          },
        ],
      },
    };
  },
  jsonld() {
    if (!this.productObj) {
      return null;
    }
    return {
      "@context": "https://schema.org",
      "@type": "Blog",
      "@id": "https://www.goa.app/blog/",
      mainEntityOfPage: "https://www.goa.app/blog/",
      name: "Goa App Blog",
      description: this.description,
      publisher: {
        "@type": "Organization",
        "@id": "https://www.goa.app",
        name: "Goa App",
        logo: {
          "@type": "ImageObject",
          "@id": "https://www.goa.app/icon.png",
          url: "https://www.goa.app/icon.png",
          width: "600",
          height: "60",
        },
      },
      blogPost: this.productObj.map((itm, index) => ({
        "@type": "BlogPosting",
        "@id": `https://www.goa.app/blog/${itm.slug}`,
        mainEntityOfPage: `https://www.goa.app/blog/${itm.slug}`,
        headline: itm.title ? itm.title : "Goa App",
        name: itm.title ? itm.title : "Goa App",
        description: itm.shortDescription ? itm.shortDescription : "Goa App",
        datePublished: itm.createdAt ? itm.createdAt : new Date(),
        dateModified: itm.createdAt ? itm.createdAt : new Date(),
        author: {
          "@type": "Person",
          "@id": "https://goa.app",
          url: "https://goa.app",
        },
        image: {
          "@type": "ImageObject",
          "@id":
            itm && itm.thumbnail && itm.thumbnail.length > 0
              ? itm.thumbnail
              : [],
          url:
            itm && itm.thumbnail && itm.thumbnail.length > 0
              ? itm.thumbnail
              : [],
          height: "362",
          width: "388",
        },
        url: `https://www.goa.app/blog/${itm.slug}`,
        keywords: itm && itm.tags && itm.tags.length > 0 ? itm.tags : [],
      })),
    };
  },

  computed: {
    disableSearch() {
      let searchStr = "";
      if (this.search) searchStr = this.search.trim();
      const re = /^[a-zA-Z0-9\s,-]{3,}/;
      return re.test(String(searchStr).toLowerCase());
    },
  },

  mounted() {
    document.body.classList.add("modalOverflow");
    if (localStorage.getItem("blogsFilter")) {
      this.listingLoading = false;
      this.restoreFilters();
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      let pagination = (this.page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      this.getListings(pagination, this.search);
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  methods: {
    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++;
          this.callback(this.page);
        }, 1000);
      }
    },

    // Store filters in Localstorage
    restoreFilters() {
      let filters = null;
      if (localStorage.getItem("blogsFilter")) {
        filters = JSON.parse(localStorage.getItem("blogsFilter"));
        this.page = filters.page;
        this.listings = filters.listings;
        this.productObj = filters.productObj;
        this.itemSelected = filters.itemSelected;
        this.scrollToJs(this.itemSelected);
      }
    },

    // Store filters in Localstorage
    storeFilters() {
      let filters = {
        page: this.page,
        listings: this.listings,
        productObj: this.productObj,
        itemSelected: this.itemSelected,
      };
      localStorage.setItem("blogsFilter", JSON.stringify(filters));
    },

    getBLogId(value) {
      if (value) {
        this.itemSelected = value;
        this.storeFilters();
      }
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return "";
      }
    },

    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      this.storeFilters();
      let pagination = (page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      //this.scrollToElement('listing-list');
      if (this.search && this.isSearchClicked) {
        this.getListings(pagination, this.search);
      } else {
        this.getListings(pagination);
      }
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, queryStr = null, sortBy = null, categories = null) {
      //this.listingLoading = true;
      var formData = new URLSearchParams();
      formData.append("skip", skip);
      if (queryStr) formData.append("query", queryStr.trim());
      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // AXIOS api call to add review api
      // window.scrollTo({
      //   top: 0,
      //   behavior: 'smooth'
      // });
      // this.$axios.post("/api/posts/app/getAllBlogs", formData, {
      //     headers: headers
      //   })
      this.$axios
        .get(
          `/api/posts/app/getAllHotels/${
            queryStr ? queryStr.trim() : "search"
          }/${skip}`
        )
        .then((response) => {
          if (queryStr) this.isSearchClicked = true;
          this.initialLoading = false;
          let value = this.getCryptKey(response.data);
          this.productObj.push(...value.hotels);
          this.listings = value;
          if (skip == 0) {
            this.page = 1;
          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            // window.scrollTo({
            //   top: 0,
            //   behavior: 'smooth'
            // });
            this.busy = false;
            this.listingLoading = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            this.listingLoading = false;
          });
        });
    },
  },
};
